export default __webpack_public_path__ + "static/media/Preg2.f9b5b043.jpg";